import { Spin } from "antd";

import { LoginPage } from "@/pages/login";

import { useAuth } from "@/entities/session";

/**
 * Пока токен проверяется, ни админку, ни форму входа показывать нельзя: форма
 * мигнёт на долю секунды у каждого, кто просто обновил страницу.
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }
  return admin === null ? <LoginPage /> : <>{children}</>;
}
